(function($) {

    $('.js-counter').countUp();

})(jQuery);